module.exports = __webpack_public_path__ + "assets/img/bhelp.3ccbefa6.png";